import type {
  ActiveDialog,
  AddInventoryProps,
  AddJournalProps,
  CloseActiveDialogProps,
  EditTransactionProps,
  EditSplitProps,
  EditInventoryProps,
  EditSaleProps,
} from "src/interfaces/adminHtmlState.interface";
import { userDontShowDialogsSelector } from "src/store/system/selector";

import { activeDialogSelector } from "./selector";

export const TOGGLE_MOBILE_OPEN = "TOGGLE_MOBILE_OPEN";
export const SET_ACTIVE_DIALOG = "SET_ACTIVE_DIALOG";
export const SET_WALKTHROUGH_ID = "SET_WALKTHROUGH_ID";

interface ToggleMobileOpenAction {
  type: typeof TOGGLE_MOBILE_OPEN;
}

interface SetActiveDialogActionGeneric {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: ActiveDialog;
}

interface SetActiveDialogActionAddInventory {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "add_inventory";
  activeDialogProps: AddInventoryProps;
}

interface SetActiveDialogActionAddJournal {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "add_journal";
  activeDialogProps: AddJournalProps;
}

interface SetActiveDialogActionEditTransaction {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "edit_transaction";
  activeDialogProps: EditTransactionProps;
}

interface SetActiveDialogActionEditSplit {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "edit_split";
  activeDialogProps: EditSplitProps;
}

interface SetActiveDialogActionEditInventory {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "edit_inventory";
  activeDialogProps: EditInventoryProps;
}

interface SetActiveDialogActionEditSale {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "edit_sale";
  activeDialogProps: EditSaleProps;
}

interface SetActiveDialogActionClose {
  type: typeof SET_ACTIVE_DIALOG;
  activeDialog: "";
  activeDialogProps: CloseActiveDialogProps;
}

type SetActiveDialogAction =
  | SetActiveDialogActionGeneric
  | SetActiveDialogActionAddInventory
  | SetActiveDialogActionAddJournal
  | SetActiveDialogActionEditTransaction
  | SetActiveDialogActionEditSplit
  | SetActiveDialogActionEditInventory
  | SetActiveDialogActionEditSale
  | SetActiveDialogActionClose;

interface SetWalkthroughIdAction {
  type: typeof SET_WALKTHROUGH_ID;
  walkthroughId: string;
}

export type AdminHtmlActionTypes =
  | ToggleMobileOpenAction
  | SetActiveDialogAction
  | SetWalkthroughIdAction;

export const toggleMobileOpen = (): AdminHtmlActionTypes => ({
  type: TOGGLE_MOBILE_OPEN,
});

export function setActiveDialog(
  activeDialog: ActiveDialog
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "",
  activeDialogProps: CloseActiveDialogProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "add_inventory",
  activeDialogProps: AddInventoryProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "add_journal",
  activeDialogProps: AddJournalProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "edit_transaction",
  activeDialogProps: EditTransactionProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "edit_split",
  activeDialogProps: EditSplitProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "edit_inventory",
  activeDialogProps: EditInventoryProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog: "edit_sale",
  activeDialogProps: EditSaleProps
): AdminHtmlActionTypes;
export function setActiveDialog(
  activeDialog,
  activeDialogProps?
): AdminHtmlActionTypes {
  return {
    type: SET_ACTIVE_DIALOG,
    activeDialog,
    activeDialogProps,
  };
}

export function setActiveDialogIfCanBeShown(
  activeDialog: ActiveDialog,
  preventDialogFromOpeningIfADialogIsAlreadyOpened = false
) {
  return (dispatch, getState): boolean => {
    const state = getState();
    const userDontShowDialogs = userDontShowDialogsSelector(state);
    if (
      userDontShowDialogs &&
      userDontShowDialogs.includes(activeDialog as any)
    )
      return false;
    if (
      preventDialogFromOpeningIfADialogIsAlreadyOpened &&
      activeDialogSelector(state)
    )
      return false;
    dispatch(setActiveDialog(activeDialog));
    return true;
  };
}

export const setWalkthroughId = (
  walkthroughId: string
): AdminHtmlActionTypes => ({
  type: SET_WALKTHROUGH_ID,
  walkthroughId,
});
